// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.StepsProcessSection_how-it-works__EhWmn {
  max-width: 1100px;
  margin: 0 auto;
  padding: 110px 20px 128px;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
@media (max-width: 768px) {
  .StepsProcessSection_how-it-works__EhWmn {
    padding: 60px 40px 39px;
  }
}
@media (min-width: 769px) and (max-width: 1080px) {
  .StepsProcessSection_how-it-works__EhWmn {
    padding: 110px 40px 128px;
  }
}
.StepsProcessSection_how-it-works__grid__SbEj1 {
  display: block;
}
.StepsProcessSection_how-it-works__intro__Mbfov {
  max-width: 660px;
  margin-bottom: 24px;
  text-align: left;
}
.StepsProcessSection_how-it-works__eyebrow__t-oIk {
  display: block;
  font-size: 13px;
  line-height: 1.2;
  margin-bottom: 13px;
  letter-spacing: 0.14em;
  font-weight: 700;
  color: #739F84;
  text-transform: uppercase;
}
.StepsProcessSection_how-it-works__title__M\\+aKB {
  font-size: 48px;
  line-height: 1.04;
  font-weight: 800;
  color: #3B3B3D;
  margin-bottom: 20px !important;
}
@media (max-width: 768px) {
  .StepsProcessSection_how-it-works__title__M\\+aKB {
    font-size: 32px;
  }
}
.StepsProcessSection_how-it-works__description__x0HVN {
  font-size: 16px;
  line-height: 1.65;
  color: rgba(19, 35, 29, 0.6784313725);
  margin-top: 0;
  margin-bottom: 0;
  max-width: 650px;
}
.StepsProcessSection_how-it-works__steps__6m5Aq {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 60px;
  align-items: start;
  margin-top: 0;
}
@media (max-width: 900px) {
  .StepsProcessSection_how-it-works__steps__6m5Aq {
    grid-template-columns: 1fr;
    gap: 36px;
  }
}
.StepsProcessSection_how-it-works__step__a9Vg\\+ {
  position: relative;
  z-index: 0;
  padding-top: 45px;
  min-height: 240px;
}
@media (max-width: 900px) {
  .StepsProcessSection_how-it-works__step__a9Vg\\+ {
    min-height: auto;
    padding-top: 42px;
  }
}
.StepsProcessSection_how-it-works__step-number__fw2-5 {
  position: absolute;
  top: -15px;
  left: -12px;
  font-size: 164px;
  line-height: 0.82;
  font-weight: 800;
  color: rgba(130, 177, 148, 0.08) !important;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  z-index: -1;
}
@media (max-width: 900px) {
  .StepsProcessSection_how-it-works__step-number__fw2-5 {
    top: 0;
    left: -4px;
  }
}
.StepsProcessSection_how-it-works__step-content__Dj4BP {
  position: relative;
  z-index: 1;
}
.StepsProcessSection_how-it-works__step-title__wbo52 {
  font-size: 24px;
  line-height: 1.28;
  font-weight: 600;
  color: #2F2F31;
  margin-bottom: 11px;
  min-height: 50px;
  display: flex;
  align-items: flex-end;
}
@media (max-width: 900px) {
  .StepsProcessSection_how-it-works__step-title__wbo52 {
    min-height: auto;
    display: block;
  }
}
.StepsProcessSection_how-it-works__step-text__siXlH {
  font-size: 16px;
  color: #3A3A3A;
  margin: 0;
  max-width: 320px;
  line-height: 1.65 !important;
  font-weight: 400 !important;
}
.StepsProcessSection_how-it-works__footer-copy__lqGIY {
  max-width: 780px;
  font-size: 16px;
  line-height: 1.65;
  color: #333;
  text-align: left;
  margin: 0;
  margin-top: 24px;
}
.StepsProcessSection_how-it-works__actions__KrpKg {
  display: flex;
  gap: 14px;
  justify-content: flex-end;
  margin-top: 23px;
  flex-wrap: wrap;
}
@media (max-width: 1080px) {
  .StepsProcessSection_how-it-works__actions__KrpKg {
    flex-direction: column;
    width: 100%;
  }
  .StepsProcessSection_how-it-works__actions__KrpKg > a {
    width: 100%;
  }
}
.StepsProcessSection_how-it-works__btn-outline__2bBVB, .StepsProcessSection_how-it-works__btn-primary__o\\+xrh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  padding: 0 20px;
  border-radius: 16px;
  text-decoration: none;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  font-size: 16px;
  line-height: 1;
  font-weight: 600;
  letter-spacing: -0.01em;
}
.StepsProcessSection_how-it-works__btn-outline__2bBVB {
  border: 1px solid rgba(130, 177, 148, 0.55);
  background: transparent;
  color: #82B194;
}
.StepsProcessSection_how-it-works__btn-outline__2bBVB:hover {
  background: rgba(130, 177, 148, 0.1);
  border-color: rgba(130, 177, 148, 0.7);
  transform: translateY(-1px);
}
.StepsProcessSection_how-it-works__btn-primary__o\\+xrh {
  background: #82B194;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 12px 24px rgba(113, 157, 130, 0.18);
}
.StepsProcessSection_how-it-works__btn-primary__o\\+xrh:hover {
  background: #719D82;
  transform: translateY(-1px);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/StepsProcessSection/StepsProcessSection.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,oFAAA;AAiBF;AAfE;EANF;IAOI,uBAAA;EAkBF;AACF;AAhBE;EAVF;IAWI,yBAAA;EAmBF;AACF;AAjBE;EACE,cAAA;AAmBJ;AAhBE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AAkBJ;AAfE;EACE,cAAA;EACA,eDYgB;ECXhB,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cDrBmB;ECsBnB,yBAAA;AAiBJ;AAdE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,8BAAA;AAgBJ;AAdI;EAPF;IAQI,eDRmB;ECyBvB;AACF;AAdE;EACE,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAgBJ;AAbE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;AAeJ;AAbI;EAPF;IAQI,0BAAA;IACA,SAAA;EAgBJ;AACF;AAbE;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;AAeJ;AAbI;EANF;IAOI,gBAAA;IACA,iBAAA;EAgBJ;AACF;AAbE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2CAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;EACA,WAAA;AAeJ;AAbI;EAZF;IAaI,MAAA;IACA,UAAA;EAgBJ;AACF;AAbE;EACE,kBAAA;EACA,UAAA;AAeJ;AAZE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;AAcJ;AAZI;EAVF;IAWI,gBAAA;IACA,cAAA;EAeJ;AACF;AAZE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;AAcJ;AAXE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AAaJ;AAVE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAYJ;AAVI;EAPF;IAQI,sBAAA;IACA,WAAA;EAaJ;EAXI;IACE,WAAA;EAaN;AACF;AATE;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,0HAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAUJ;AAPE;EACE,2CAAA;EACA,uBAAA;EACA,cDtKmB;AC+KvB;AAPI;EACE,oCAAA;EACA,sCAAA;EACA,2BAAA;AASN;AALE;EACE,mBDhLmB;ECiLnB,WAAA;EACA,6BAAA;EACA,iDAAA;AAOJ;AALI;EACE,mBAAA;EACA,2BAAA;AAON","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.how-it-works {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 110px 20px 128px;\n  font-family: $font-main;\n\n  @media (max-width: $breakpoint-md) {\n    padding: 60px 40px 39px;\n  }\n\n  @media (min-width: 769px) and (max-width: 1080px) {\n    padding: 110px 40px 128px;\n  }\n\n  &__grid {\n    display: block;\n  }\n\n  &__intro {\n    max-width: 660px;\n    margin-bottom: 24px;\n    text-align: left;\n  }\n\n  &__eyebrow {\n    display: block;\n    font-size: $font-size-caption;\n    line-height: 1.2;\n    margin-bottom: 13px;\n    letter-spacing: 0.14em;\n    font-weight: 700;\n    color: $color-primary-hover;\n    text-transform: uppercase;\n  }\n\n  &__title {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    color: #3B3B3D;\n    margin-bottom: 20px !important;\n\n    @media (max-width: $breakpoint-md) {\n      font-size: $font-size-title-mobile;\n    }\n  }\n\n  &__description {\n    font-size: 16px;\n    line-height: 1.65;\n    color: #13231dad;\n    margin-top: 0;\n    margin-bottom: 0;\n    max-width: 650px;\n  }\n\n  &__steps {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 60px;\n    align-items: start;\n    margin-top: 0;\n\n    @media (max-width: 900px) {\n      grid-template-columns: 1fr;\n      gap: 36px;\n    }\n  }\n\n  &__step {\n    position: relative;\n    z-index: 0;\n    padding-top: 45px;\n    min-height: 240px;\n\n    @media (max-width: 900px) {\n      min-height: auto;\n      padding-top: 42px;\n    }\n  }\n\n  &__step-number {\n    position: absolute;\n    top: -15px;\n    left: -12px;\n    font-size: 164px;\n    line-height: 0.82;\n    font-weight: 800;\n    color: rgba(130, 177, 148, .08) !important;\n    user-select: none;\n    pointer-events: none;\n    z-index: -1;\n\n    @media (max-width: 900px) {\n      top: 0;\n      left: -4px;\n    }\n  }\n\n  &__step-content {\n    position: relative;\n    z-index: 1;\n  }\n\n  &__step-title {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    color: #2F2F31;\n    margin-bottom: 11px;\n    min-height: 50px;\n    display: flex;\n    align-items: flex-end;\n\n    @media (max-width: 900px) {\n      min-height: auto;\n      display: block;\n    }\n  }\n\n  &__step-text {\n    font-size: 16px;\n    color: #3A3A3A;\n    margin: 0;\n    max-width: 320px;\n    line-height: 1.65 !important;\n    font-weight: 400 !important;\n  }\n\n  &__footer-copy {\n    max-width: 780px;\n    font-size: 16px;\n    line-height: 1.65;\n    color: #333;\n    text-align: left;\n    margin: 0;\n    margin-top: 24px;\n  }\n\n  &__actions {\n    display: flex;\n    gap: 14px;\n    justify-content: flex-end;\n    margin-top: 23px;\n    flex-wrap: wrap;\n\n    @media (max-width: 1080px) {\n      flex-direction: column;\n      width: 100%;\n\n      &>a {\n        width: 100%;\n      }\n    }\n  }\n\n  &__btn-outline,\n  &__btn-primary {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 46px;\n    padding: 0 20px;\n    border-radius: 16px;\n    text-decoration: none;\n    transition: background-color .2s ease, border-color .2s ease, color .2s ease, transform .2s ease, box-shadow .2s ease;\n    font-size: 16px;\n    line-height: 1;\n    font-weight: 600;\n    letter-spacing: -.01em;\n  }\n\n  &__btn-outline {\n    border: 1px solid rgba(130, 177, 148, 0.55);\n    background: transparent;\n    color: $color-primary;\n\n    &:hover {\n      background: rgba(130, 177, 148, 0.10);\n      border-color: rgba(130, 177, 148, 0.70);\n      transform: translateY(-1px);\n    }\n  }\n\n  &__btn-primary {\n    background: $color-primary;\n    color: #fff;\n    border: 1px solid transparent;\n    box-shadow: 0 12px 24px rgba(113, 157, 130, 0.18);\n\n    &:hover {\n      background: #719D82;\n      transform: translateY(-1px);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"how-it-works": `StepsProcessSection_how-it-works__EhWmn`,
	"how-it-works__grid": `StepsProcessSection_how-it-works__grid__SbEj1`,
	"how-it-works__intro": `StepsProcessSection_how-it-works__intro__Mbfov`,
	"how-it-works__eyebrow": `StepsProcessSection_how-it-works__eyebrow__t-oIk`,
	"how-it-works__title": `StepsProcessSection_how-it-works__title__M+aKB`,
	"how-it-works__description": `StepsProcessSection_how-it-works__description__x0HVN`,
	"how-it-works__steps": `StepsProcessSection_how-it-works__steps__6m5Aq`,
	"how-it-works__step": `StepsProcessSection_how-it-works__step__a9Vg+`,
	"how-it-works__step-number": `StepsProcessSection_how-it-works__step-number__fw2-5`,
	"how-it-works__step-content": `StepsProcessSection_how-it-works__step-content__Dj4BP`,
	"how-it-works__step-title": `StepsProcessSection_how-it-works__step-title__wbo52`,
	"how-it-works__step-text": `StepsProcessSection_how-it-works__step-text__siXlH`,
	"how-it-works__footer-copy": `StepsProcessSection_how-it-works__footer-copy__lqGIY`,
	"how-it-works__actions": `StepsProcessSection_how-it-works__actions__KrpKg`,
	"how-it-works__btn-outline": `StepsProcessSection_how-it-works__btn-outline__2bBVB`,
	"how-it-works__btn-primary": `StepsProcessSection_how-it-works__btn-primary__o+xrh`
};
export default ___CSS_LOADER_EXPORT___;
